// extracted by mini-css-extract-plugin
export default {"navigationList":"Navigation_navigationList__hpbno","collapsed":"Navigation_collapsed__FehTW"};